import { type FC, type ReactElement } from 'react'
import {
  type Control,
  Controller,
  type UseControllerProps,
} from 'react-hook-form'

import { RxLpChErrorMessage } from '../RxLpChErrorMessage'

import {
  type CheckboxGroupFieldsetProps,
  RxLpChCheckboxGroupFieldset,
} from './RxLpChCheckboxGroupFieldset'

type CheckboxGroupControllerProps = Omit<
  CheckboxGroupFieldsetProps,
  'onChange' | 'value'
> &
  Pick<UseControllerProps, 'rules'> & {
    containerClassName?: string
    control: Control
    name: string
  }

type ValueType = CheckboxGroupFieldsetProps['value']

export const RxLpChCheckboxGroupController: FC<
  CheckboxGroupControllerProps
> = ({ checkboxes, className, containerClassName, control, name, rules }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }): ReactElement => {
        if (rules) {
          return (
            <div className={containerClassName}>
              <RxLpChCheckboxGroupFieldset
                checkboxes={checkboxes}
                className={className}
                onChange={onChange}
                value={value as ValueType}
              />
              <RxLpChErrorMessage name={name} />
            </div>
          )
        }

        return (
          <RxLpChCheckboxGroupFieldset
            checkboxes={checkboxes}
            className={className}
            onChange={onChange}
            value={value as ValueType}
          />
        )
      }}
      rules={rules}
    />
  )
}
